var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('p',{staticClass:"text-subtitle-1"},[_vm._v("\n        "+_vm._s(_vm.$t('views.errors.not_found.page_not_found'))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }